module.exports = __webpack_public_path__ + "img/arrow-down-white.59a2e202.svg";